module.exports = "/_next/static/images/slide-easiConnect-408d09f67bab024473db725d9cae39a7.png.webp";